import gql from 'graphql-tag';
import { compose, graphql } from 'react-apollo';

import ForceLogin from './ForceLogin';

const AcceptForceLoginMutation = gql`
  mutation acceptForceLogin($token: String!) {
    acceptForceLogin(token: $token) {
      token,
      user {
        id
        
        email
        phone
        
        receiveNewsletter
        
        companyInformation
        companyName
        companyRegistrationNumber
        companyVatNumber

        invoiceFirstName
        invoiceLastName
        
        invoiceStreet
        invoiceHouseNumber
        invoiceAddressLine1
        invoiceAddressLine2
        invoiceZip
        invoiceCity
        invoiceCountyState
        invoiceCountry

        anotherDeliveryAddress
        deliveryStreet
        deliveryHouseNumber
        deliveryAddressLine1
        deliveryAddressLine2
        deliveryZip
        deliveryCity
        deliveryCountyState
        deliveryCountry

        saleTaxCertificate

        discount
      }
      country {
        id
        title
        name
        details
        VATrate
        currency
        language
        code
        flag
        weightUnit
        states {
          id
          name
          title
          vatRate
        }
      }
    }
  }
`;

interface IInputProps {
  children?: any;
}

interface IResponse {
  data: any;
}

export default compose(
  graphql<IInputProps, IResponse>(AcceptForceLoginMutation, {
    name: 'acceptForceLogin',
    options: {
      fetchPolicy: 'network-only',
    },
  })
)(ForceLogin);



// WEBPACK FOOTER //
// ./src/pages/ForceLogin/index.tsx